import start_white from "../assets/icons/events/event-start-white.png";
import start from "../assets/images/nodes/21.png";
import stop from "../assets/images/nodes/22.png";
import terminate from "../assets/images/nodes/25.png";
import script_task from "../assets/icons/node/script (2).png";
import or from "../assets/images/nodes/23.png";
import xor from "../assets/images/nodes/20.png";
import service from "../assets/icons/node/integration.png";
import send_email from "../assets/icons/node/message (1).png";
import ai_agent from "../assets/icons/node/robot.png";
import planner_llm from "../assets/icons/node/chatbot.png";
import sub_process from "../assets/icons/node/steps.png";
import and from "../assets/images/nodes/19.png";
import openai2 from "..//assets/icons/node/chat-gpt.png";
import salesforce from "../assets/icons/node/salesforce.png";
import sap from "../assets/icons/node/sap.png";
import servicenow from "../assets/icons/node/serviceNowLogo.png";
import mulesoft from "../assets/icons/node/mulesoft_logo_icon.png";

const imageMap = {
  1: start,
  2: stop,
  3: terminate,
  4: script_task,
  5: or,
  6: xor,
  7: service,
  8: send_email,
  9: ai_agent,
  10: planner_llm,
  11: sub_process,
  12: and,
  13: openai2,
  14: salesforce,
  15: sap,
  16: servicenow,
  17: mulesoft,
};

export default imageMap;
